import { isEmpty } from 'bold-ui'

import { ConsultaSeguimentoIndicatorResultadoText } from '../../components/ConsultaSeguimentoIndicatorResultado'
import { PassouFalhouEnum } from '../../model-consultaSeguimento'
import { hasAnySim, isAllFilled, isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta11ExemplosEnum,
  ConsultaSeguimentoPergunta11Model,
} from './model-consultaSeguimentoPergunta11'

const pergunta11ExemplosEnum = Object.values(ConsultaSeguimentoPergunta11ExemplosEnum)
const pergunta11ExemplosPassouEnumValues = [
  ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_QUANDO_VOCE_SORRI,
  ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_QUANDO_VOCE_ENTRA_NO_QUARTO,
  ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_QUANDO_VOCE_VOLTA,
]
const pergunta11ExemplosFalhouEnumValues = [
  ConsultaSeguimentoPergunta11ExemplosEnum.ESTA_SEMPRE_SORRINDO,
  ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_PARA_BRINQUEDO_OU_ATIVIDADE,
  ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_AO_ACASO_OU_SEM_MOTIVO,
]

export function isPergunta11ExemplosAllFilled(
  value: ConsultaSeguimentoPergunta11Model['PERGUNTA_11_EXEMPLOS']
): boolean {
  const allExemplos = { ...value?.PASSOU, ...value?.FALHOU }
  return isAllFilled(allExemplos, pergunta11ExemplosEnum)
}

export function isPergunta11ExemplosAllNao(value: ConsultaSeguimentoPergunta11Model['PERGUNTA_11_EXEMPLOS']): boolean {
  const allExemplos = { ...value?.PASSOU, ...value?.FALHOU }
  return isAllNao(allExemplos, pergunta11ExemplosEnum)
}

export function isPergunta11ExemplosPassouAllNao(
  value: ConsultaSeguimentoPergunta11Model['PERGUNTA_11_EXEMPLOS']
): boolean {
  const exemplosPassou = value?.PASSOU
  return isAllNao(exemplosPassou, pergunta11ExemplosPassouEnumValues)
}

export function isPergunta11ExemplosFalhouAllNao(
  value: ConsultaSeguimentoPergunta11Model['PERGUNTA_11_EXEMPLOS']
): boolean {
  const exemplosFalhou = value?.FALHOU
  return isAllNao(exemplosFalhou, pergunta11ExemplosFalhouEnumValues)
}

export function hasPergunta11ExemplosPassouAnySim(
  value: ConsultaSeguimentoPergunta11Model['PERGUNTA_11_EXEMPLOS']
): boolean {
  const exemplosPassou = value?.PASSOU ?? {}
  return !isEmpty(exemplosPassou) && hasAnySim(exemplosPassou)
}

export function hasPergunta11ExemplosFalhouAnySim(
  value: ConsultaSeguimentoPergunta11Model['PERGUNTA_11_EXEMPLOS']
): boolean {
  const exemplosFalhou = value?.FALHOU ?? {}
  return !isEmpty(exemplosFalhou) && hasAnySim(exemplosFalhou)
}

export function getPergunta11ResultadoText(
  value: ConsultaSeguimentoPergunta11Model
): ConsultaSeguimentoIndicatorResultadoText {
  const isExemplosAllNao = isPergunta11ExemplosAllNao(value?.PERGUNTA_11_EXEMPLOS)
  const isPassouAllNao = isPergunta11ExemplosPassouAllNao(value?.PERGUNTA_11_EXEMPLOS)
  const isFalhouAllNao = isPergunta11ExemplosFalhouAllNao(value?.PERGUNTA_11_EXEMPLOS)
  const hasPassouAnySim = hasPergunta11ExemplosPassouAnySim(value?.PERGUNTA_11_EXEMPLOS)
  const hasFalhouAnySim = hasPergunta11ExemplosFalhouAnySim(value?.PERGUNTA_11_EXEMPLOS)
  const isSimSomentePassou = hasPassouAnySim && isFalhouAllNao
  const isSimSomenteFalhou = hasFalhouAnySim && isPassouAllNao

  const textResultadoPassouByFrequencia =
    value?.PERGUNTA_11_FREQUENCIA === PassouFalhouEnum.PASSOU ? 'Os mais frequentes são exemplos de Passou:' : ''

  const textResultadoFalhouByFrequencia =
    value?.PERGUNTA_11_FREQUENCIA === PassouFalhouEnum.FALHOU ? 'Os mais frequentes são exemplos de Falhou:' : ''

  const textResultadoFalhouByAllExemplosNao = isExemplosAllNao ? 'Não para todos' : textResultadoFalhouByFrequencia

  const textResultadoPassou = isSimSomentePassou ? 'Sim somente para exemplos Passou:' : textResultadoPassouByFrequencia

  const textResultadoFalhou = isSimSomenteFalhou
    ? 'Sim somente para exemplos FALHOU:'
    : textResultadoFalhouByAllExemplosNao

  return {
    FALHOU: textResultadoFalhou,
    PASSOU: textResultadoPassou,
  }
}
